import ToggleButton from './ToggleButton.vue';

// @ts-ignore
ToggleButton.install = (Vue) => {
  Vue.component((ToggleButton as any).options.name, ToggleButton);
};

export default ToggleButton;
